import * as React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import "@fontsource/inter/500.css";

interface Props {
  onClick: () => void;
  showHideAll: boolean;
  showAllText: string;
  hideAllText: string;
}

const ToggleAllText = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 10px;
  color: ${theme.colors.textSecondary};
  cursor: pointer;
  user-select: none;
  text-transform: uppercase;
  &:hover {
    color: ${theme.colors.primary};
  }
`;

const ToggleAllTextButton: React.FC<Props> = ({
  onClick,
  showHideAll,
  showAllText,
  hideAllText,
}) => {
  return (
    <ToggleAllText onClick={onClick}>
      {showHideAll ? hideAllText : showAllText}
    </ToggleAllText>
  );
};

export default ToggleAllTextButton;
